import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	tryAgain: {
		id: 'eoc-on-call.ui.error.try-again',
		defaultMessage: 'Try again',
		description: 'Try again button.',
	},
	errorTitle: {
		id: 'eoc-on-call.ui.error.error-title',
		defaultMessage: "We're having some problem",
		description: 'On-call error title.',
	},
	errorDescription: {
		id: 'eoc-on-call.ui.error.error-description',
		defaultMessage: 'We are unable to fetch your team at this time.',
		description: 'On-call error description.',
	},
});
